import {Header, Pagination, TableSkeleton} from '@/components';

import Filters from './Filters';
import ProcessorTxTable from './ProcessorTxTable';
import useProcessorTransactionList from './useProcessorTransactionList';

const TransactionList = () => {
  const {
    isLoading,
    txList,
    pageInfo,
    currentFilters,
    filtersToApply,
    filterCount,
    selectCurrentFilters,
    handleApplyFilters,
    selectAppliedFilters,
    clearFilters,
    handleOffsetChange,
  } = useProcessorTransactionList();

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title={`Processor Transactions`} />

      <Filters
        transactions={txList}
        filterCount={filterCount}
        currentFilters={currentFilters}
        filtersToApply={filtersToApply}
        clearFilters={clearFilters}
        selectCurrentFilters={selectCurrentFilters}
        selectAppliedFilters={selectAppliedFilters}
        handleApplyFilters={handleApplyFilters}
      />

      <section className="pt-5 md:pt-5">
        {isLoading ? <TableSkeleton /> : <ProcessorTxTable items={txList} />}
      </section>

      {txList && txList.length > 0 ? (
        <Pagination
          mode="offset"
          offset={pageInfo.offset}
          limit={pageInfo.limit}
          hasMore={pageInfo.hasMore}
          isEmpty={pageInfo.isEmpty}
          onOffsetChange={handleOffsetChange}
        />
      ) : null}
    </main>
  );
};

export default TransactionList;
